import { object, string } from 'yup';
import { IRegisterToProdValidationSchema } from 'views/OAuthManagement/interfaces/IRegisterToProdValidationSchema';

export const registerToProdValidationSchema = object<IRegisterToProdValidationSchema>({
  name: string().required('Name is Required'),
  redirectURIs: string().required('Callback URLs / Redirect URIs are Required'),
});

export default registerToProdValidationSchema;
